import React from "react";
import useStyles from "isomorphic-style-loader/useStyles";
import classes from "./style.module.scss"
import BottomToTop from "../../../../../components/transitions/bottom-to-top";
import { BlackMask } from "../../../../../components/mask";
import { OptionalCoupon } from "../../../../me/pages/coupons/components/coupone-list";
import { BigButton } from "../../../../../components/button";
import { getAddOnDelPrice, isFlashSales, unitPrice } from "../../../../../../utils/product";
import { Iconfont } from "../../../../../components/icon/iconfont";
import { FormattedMessage, useIntl } from "react-intl";

const DiscountAlert = props => {
    useStyles(classes)
    const { show, setShow, amount, percent, handleAddToCart, carting, selectedVariant, selectedProduct, couponActivity, isEstimated, lower } = props
    const { couponActivitySimpleName, couponDiscount, estimatedPrice, coupons } = selectedVariant?.couponDiscount ?
        { ...selectedProduct?.couponActivity, couponDiscount: selectedVariant?.couponDiscount } :
        selectedProduct?.couponActivity || {}
    const intl = useIntl()

    const isEnabled = v => {
        if (!v) return true
        return v.status === '1' && v.inventory > 0 || (v.domesticDelivery && v.domesticDelivery.enabled && v.domesticDelivery.inventory > 0)
    }

    const isDisabled = !isEnabled(selectedVariant) || (isFlashSales(selectedProduct) && selectedProduct?.promotion?.salesQty >= selectedProduct?.promotion?.totalQty);

    return <>
        <BottomToTop in={show} className={`${classes.DiscountAlert}`}>
            <div>
                <div className={classes.Hd}>
                    <span className={classes.Content}>
                        <FormattedMessage id="promotion_details" defaultMessage={'Promotion Details'} />
                    </span>
                    <Iconfont className={classes.Icon} onClick={e => setShow(false)}>&#xe69a;</Iconfont>
                </div>
                <div className={classes.Bd}>
                    {
                        isEstimated && estimatedPrice && <React.Fragment>
                            {/*  折后价 */}
                            <div className={classes.FinalPriceBox}>
                                <div className={classes.FinalPrice}>
                                    <div className={classes.FinalPriceTitle}>
                                        <FormattedMessage id="estimated_price" defaultMessage={'Estimated Price'} />
                                    </div>
                                    <div className={classes.FinalPriceTag}>
                                        {unitPrice(estimatedPrice)}
                                    </div>
                                </div>
                            </div>

                            {/* 折后计算 */}
                            <div className={classes.PriceCountBox}>
                                <div className={classes.PriceCountTitle}>
                                    <FormattedMessage id="buy_now_enjoy" defaultMessage={'Buy now to enjoy the following benefits'} />
                                </div>
                                <div className={classes.PriceLine}>
                                    <div className={classes.PriceType}>
                                        <FormattedMessage id="discount_price" defaultMessage={'Discount Price'} />
                                    </div>
                                    <div className={classes.OriginPrice}>
                                        <p className={classes.Discount}>{unitPrice(lower)}</p>
                                        <p className={classes.Origin}>{`(${intl.formatMessage({ id: 'original_price', defaultMessage: 'Original Price' })} ${unitPrice(getAddOnDelPrice(selectedProduct))})`}</p>
                                    </div>
                                </div>
                                <div className={classes.DiscountLine}>
                                    <div className={classes.DicountMsg}>{couponActivitySimpleName}</div>
                                    <div className={classes.DicountPrice}>{"-" + unitPrice(couponDiscount)}</div>
                                </div>
                                <div className={classes.FinalLine}>
                                    <div className={classes.PriceFinal}>
                                        <span><FormattedMessage id="estimated_price" defaultMessage={'Estimated Price'} /></span>
                                        <span className={classes.PriceDisountTag}>{percent}</span>
                                    </div>
                                    <div className={classes.PriceFinalCount}>{unitPrice(estimatedPrice)}</div>
                                </div>
                            </div>

                            {/* 加购按钮 */}
                            <div className={classes.AddToCartBtn}>
                                <BigButton onClick={() => {
                                    if (!isDisabled) {
                                        handleAddToCart?.()
                                    }
                                }} loading={carting} disabled={isDisabled}>
                                    <FormattedMessage id="add_to_cart" />
                                </BigButton>
                                <span className={classes.AddToCartTip}>
                                    <FormattedMessage id="discount_shown_estimated" defaultMessage={'Discounts shown are estimated and subject to coupon rules. Final price may vary.'} />
                                </span>
                            </div>
                        </React.Fragment>
                    }

                    {/* 优惠券列表 */}
                    {
                        coupons?.length > 0 &&
                        <div className={classes.CouponListBox}>
                            <div className={classes.CouponTitle}><FormattedMessage id="coupon" defaultMessage={'Coupon'} /></div>
                            <div className={classes.CouponList}>
                                {
                                    coupons?.map((c, index) => {
                                        return <OptionalCoupon key={c?.id} coupon={c} isBest={c?.bestCoupon && isEstimated} />
                                    })
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>
        </BottomToTop>

        {
            show && <BlackMask onClick={() => setShow(false)} />
        }
    </>
}


const PriceDiscountAlert = props => {
    useStyles(classes)
    const { per, showProm, isEstimated, setShowProm, selectedVariant, productAddToCart, setShowAddToCartModal, amount } = props

    const percent = "-" + (per || 0) + '%'

    const handleClick = () => {
        //  打开弹窗
        if (window.GeekoSensors) {
            window.GeekoSensors.Track('ELClick', {
                clicks: "estimated_price",
            })
        }
        setShowProm(true)
    }

    const handleAddToCart = async () => {
        if (window.GeekoSensors) {
            window.GeekoSensors.Track('ELClick', {
                clicks: "get_coupons",
            })
        }
        if (!selectedVariant) {
            setShowAddToCartModal(true)
            setShowProm(false)
            return
        }
        await productAddToCart()
        setShowAddToCartModal(false)
    }

    return <React.Fragment>
        {/*  预估折后 比例 */}
        {
            isEstimated &&
            <span className={classes.PriceDiscountBox} onClick={handleClick}>
                <span className={classes.PriceTxt}><FormattedMessage id="estimated" defaultMessage={'Estimated'} /></span>
                <span className={classes.PriceDiscount}>{unitPrice(amount)}</span>
            </span>
        }

        <DiscountAlert {...props} show={showProm} setShow={setShowProm} percent={percent} handleAddToCart={handleAddToCart} />
    </React.Fragment>
}

export default PriceDiscountAlert